import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { ExtendedAttribute } from 'app/library/extended-attributes/models/extended-attribute';
import { ExtendedAttributeFilter } from 'app/library/extended-attributes/models/extended-attribute-filter.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-range-filter',
    templateUrl: './range-filter.component.html',
    styleUrls: ['./range-filter.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RangeFilterComponent extends UnsubscribeOnDestroy implements OnInit, OnChanges {
    @Input()
    userAttribute: ExtendedAttribute;

    @Input()
    userAttributeFilter: ExtendedAttributeFilter;

    @Output()
    addedToList = new EventEmitter<IChoosenFilterInterface[]>();

    list: IChoosenFilterInterface[] = [];
    minValue = new FormControl();
    maxValue = new FormControl();

    lowRangeSliderValue: number;
    highRangeSliderValue: number;
    options: Options = {};
    isSliderVisible: boolean = false;

    private _initValues(): void {
        if (!this.userAttribute?.id) {
            return;
        }

        if (this.userAttributeFilter?.min && this.userAttributeFilter?.max) {
            this.isSliderVisible = true;

            this.lowRangeSliderValue = this.userAttributeFilter.min ? parseInt(this.userAttributeFilter.min) : this.lowRangeSliderValue;
            this.minValue.setValue(this.userAttributeFilter.min);
            this.highRangeSliderValue = this.userAttributeFilter.max ? parseInt(this.userAttributeFilter.max) : this.highRangeSliderValue;
            this.maxValue.setValue(this.userAttributeFilter.max);
        } else {
            this.isSliderVisible = false;
        }

        this.options = {
            floor: this.minValue.value,
            ceil: this.maxValue.value,
        };

        this.list.forEach((filter) => {
            if (filter.entity.id === this.userAttribute.id) {
                this.lowRangeSliderValue = filter.rangeValue1 as number;
                this.highRangeSliderValue = filter.rangeValue2 as number;
                this.minValue.setValue(this.lowRangeSliderValue);
                this.maxValue.setValue(this.highRangeSliderValue);
            }
        });
    }

    constructor(private _allUsersService: AllUsersApiService, private _translateService: TranslateService) {
        super();
    }

    ngOnInit(): void {
        this._allUsersService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.list = filters;
            this._initValues();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['userAttribute'] || changes['userAttributeFilter']) {
            this._initValues();
        }
    }

    valueChange(change: ChangeContext): void {
        if (change) {
            this.minValue.setValue(change.value);
            this.maxValue.setValue(change.highValue);
        } else {
            if (this.minValue.value < this.options.floor) {
                this.lowRangeSliderValue = this.options.floor;
            } else {
                this.lowRangeSliderValue = this.minValue.value;
            }

            if (this.maxValue.value > this.options.ceil) {
                this.highRangeSliderValue = this.options.ceil;
            } else {
                this.highRangeSliderValue = this.maxValue.value;
            }
        }

        setTimeout(() => {
            this.addedToList.emit([
                ...this.list.filter((value) => value.entity.id !== this.userAttribute.id),
                {
                    entity: { id: this.userAttribute.id, type: 'ExtendedAttribute' },
                    valueToShow: `${this._translateService.instant(this.userAttribute.translationKey)}: ${this.lowRangeSliderValue} - ${this.highRangeSliderValue}`,
                    attributeName: this.userAttribute.name,
                    attributeId: this.userAttribute.id,
                    isRange: true,
                    rangeValue1: this.lowRangeSliderValue,
                    rangeValue2: this.highRangeSliderValue,
                },
            ]);
        });
    }
}
